import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import BootstrapVue from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap-reboot.min.css'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import './styles/main.sass'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

var firebaseConfig = {
  apiKey: "AIzaSyBwhvnHqY502wkx2fYJvjm3cuOz6I91MMU",
  authDomain: "cryptocash-4d4e5.firebaseapp.com",
  databaseURL: "https://cryptocash-4d4e5.firebaseio.com",
  projectId: "cryptocash-4d4e5",
  storageBucket: "cryptocash-4d4e5.appspot.com",
  messagingSenderId: "270164039281",
  appId: "1:270164039281:web:b5383b333f4139febd6dd0",
  measurementId: "G-9QZL3VP98F"
};

firebase.initializeApp(firebaseConfig)

async function applyRemoteTextOverrides() {
  try {
    const doc = await firebase
      .firestore()
      .collection('settings')
      .doc('text-overrides')
      .get()

    if (!doc.exists) {
      return
    }

    const overrides = doc.data() || {}

    Object.keys(overrides).forEach((locale) => {
      if (overrides[locale] && typeof overrides[locale] === 'object') {
        i18n.mergeLocaleMessage(locale, overrides[locale])
      }
    })
  } catch (error) {
    console.error('Failed to load text overrides', error)
  }
}

Vue.config.productionTip = true

Vue.use(BootstrapVue)

Vue.use(LayoutPlugin)

async function bootstrap() {
  await applyRemoteTextOverrides()

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()